import {Component} from "react"


class ValuationDescription extends Component<any> {
    render() {
        return (
            <div className="valuation-description"> 
                <p>Value your home</p>
            </div>
        )
    }
}

export default ValuationDescription
